const POUNDS_IN_KG = 2.20462;
const CM_IN_INCH = 2.54;
export const METERS_IN_MILE = 1609.34;

export const exactLbsToKg = (value: number) => {
  return value / POUNDS_IN_KG;
};

export const exactKgtoLbs = (value: number) => {
  return value * POUNDS_IN_KG;
};

export const exactInchtoCm = (value: number) => {
  return value * CM_IN_INCH;
};

export const exactCmtoInch = (value: number) => {
  return value / CM_IN_INCH;
};

export const exactMilesToMeters = (value: number) => {
  return value * METERS_IN_MILE;
};

export const exactMetersToMiles = (meters: number) => {
  return meters / METERS_IN_MILE;
};

export interface FtIn {
  ft: number;
  in: number;
}

export const roundedCmToFtIn = (cm: number) => {
  const totalInches = exactCmtoInch(cm);

  const feet = Math.floor(totalInches / 12);
  const inches = Math.round(totalInches % 12);

  if (inches === 12) {
    return { ft: feet + 1, in: 0 };
  } else {
    return { ft: feet, in: inches };
  }
};

export const exactFtInToCm = (ftIn: FtIn) => {
  const totalInches = ftIn.ft * 12 + ftIn.in;
  return Math.round(exactInchtoCm(totalInches));
};

/**
 * Round kilo- to deci- (e.g. kilograms/kg to decigrams/dg). Used for comparing
 * weight values in kg which may have originated in lbs.
 */
export const roundKtoD = (value: number) => Math.round(value * 10_000);
